<mat-card class="slidecontent">

<div class="headcontent">
    
  <div class="pophead">
      <h3>Add Activity Item</h3>
     
        <mat-icon  class="close" (click)="closecreateTouches(closeTouches)" >close</mat-icon>
      
    </div>
  </div>
    <div class="dialog_content">
     
        <form  class="fix-mat-form-field" >
          <mat-form-field>
              <mat-label>Activity Type</mat-label>
              <mat-select value="">
                <mat-option value="">Note </mat-option>
                <mat-option value="">Phone Call</mat-option>
                <mat-option value="" >Email</mat-option>
                <mat-option value="">Meeting</mat-option>
                <mat-option value="">Other</mat-option>
              </mat-select>
            </mat-form-field>  

            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select value="">
                <mat-option value="" >Completed</mat-option>
                <mat-option value="">Unavailable </mat-option>
                <mat-option value="">Left Message</mat-option>
                <mat-option value="" >Cancelled</mat-option>
                <mat-option value="">Other</mat-option>
              </mat-select>
            </mat-form-field> 

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Date </mat-label>
                    <input matInput placeholder="Select date" >
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
              <mat-form-field appearance="legacy" fxFlex>
                  <mat-label>Time </mat-label>
                  <input matInput placeholder="Select time" >
              </mat-form-field>
          </div>

          <mat-form-field>
              <mat-label>Notes</mat-label>
              <textarea matInput
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="4"
                        cdkAutosizeMaxRows="5"></textarea>
            </mat-form-field>


            
        </form>

    </div>


<div class="actionBtn">

<button mat-flat-button class="cancel" (click)="closecreateTouches(closeTouches)" >Cancel</button>
<button mat-flat-button class="calltoaction" type="submit"  color="primary">Create</button>
</div>


</mat-card >

<div class="overlay" (click)="closecreateTouches(closeTouches)"></div>

  